import { TITEL_OPTIONS } from "./titelOptions";

/**
 * TitelSelect — Dropdown-Ersatz für den früheren freien Titel-Freitext.
 *
 * Props:
 *  - id: eindeutiges DOM-ID (auch für data-testid).
 *  - label: sichtbares Label; default "Titel".
 *  - value: aktueller String-Wert.
 *  - onChange: (v: string) => void.
 *  - className: optionales Layout-Wrapper-Class.
 */
export const TitelSelect = ({
  id,
  label = "Titel",
  value,
  onChange,
  className = "",
}) => (
  <label className={`block ${className}`}>
    <span className="eyebrow text-[#505a74]">{label}</span>
    <div className="relative mt-2">
      <select
        id={id}
        data-testid={`form-input-${id}`}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="block w-full appearance-none bg-white border border-[#e8e6df] rounded-sm px-4 py-3 pr-10 text-[15px] focus:outline-none focus:border-[#0a1128] transition"
      >
        {TITEL_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[#505a74]">▾</span>
    </div>
  </label>
);
